import { createUseStyles } from 'react-jss'
import { WHITE, GREEN } from '@omnilert/components'

export default createUseStyles({
  container: {
    bottom: -37,
    display: 'flex',
    justifyContent: 'center',
    left: 0,
    position: 'absolute',
    right: 0
  },
  contentContainer: {
    '& svg': {
      height: '12px',
      width: '18px'
    },
    alignItems: 'center',
    background: GREEN,
    border: '1px solid var(--new-Message-indicator-Border)',
    borderRadius: '50px',
    boxSizing: 'border-box',
    color: WHITE,
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'row',
    fontSize: '12px',
    fontWeight: 'bold',
    height: '30px',
    justifyContent: 'center',
    padding: '7px 15px',
    textTransform: 'uppercase',
    top: '0px',
    width: '189px',
    zIndex: 1
  }
})
